import React, { useContext } from "react";
import { Redirect, Route, Switch } from "react-router";
import Layout from "../../Layout";
import menu from "./menu";
import {
  PermissionContext,
  Roles,
  withPermission,
} from "../../../util/PermissionProvider";
import MemberListingPage from "../../hkiff/MemberManagementPages/MemberListingPage";
import MemberDetailPage from "../../hkiff/MemberManagementPages/MemberDetailPage";
import MemberRecordPage from "../../hkiff/MemberManagementPages/MemberRecordPage";
import MemberPlanListingPage from "../../hkiff/MemberManagementPages/MemberPlanListingPage";
import MemberGiftListingPage from "../../hkiff/MemberManagementPages/MemberGiftListingPage";
import MemberConfigurationPage from "../../hkiff/MemberManagementPages/MemberConfigurationPage";
import MemberEmailSettingsPage from "../../hkiff/MemberManagementPages/MemberEmailSettingsPage";
import MemberPlanDetailPage from "../../hkiff/MemberManagementPages/MemberPlanDetailPage";
import MemberGiftDetailPage from "../../hkiff/MemberManagementPages/MemberGiftDetailPage";
import OrderListingPage from "../OrderListingPage";
import OrderDetailsPage from "../OrderDetailsPage";
import VoucherListingPage from "../VoucherListingPage";
import VoucherDetailPage from "../VoucherDetailPage";
import VoucherEditingPage from "../VoucherEditingPage";
import CouponListingPage from "../CouponListingPage";
import CouponDetailsPage from "../CouponDetailsPage";
import CouponEditingPage from "../CouponEditingPage";
import MerchandiseListingPage from "../MerchandiseListingPage";
import MerchandiseEditingPage from "../MerchandiseEditingPage";
import BannerListingPage from "../BannerListingPage";
import BannerEditingPage from "../BannerEditingPage";
import PlanFeatureListingPage from "../PlanFeatureListingPage";
import PlanFeatureEditingPage from "../PlanFeatureEditingPage";
import PartnerBenefitListPage from "../PartnerBenefitListPage";
import PartnerBenefitEditingPage from "../PartnerBenefitEditingPage";
import NewsListingPage from "../NewsListingPage";
import NewsEditingPage from "../NewsEditingPage";
import FaqListingPage from "../FaqListingPage";
import FaqEditingPage from "../FaqEditingPage";
import FaqCategoryListingPage from "../FaqCategoryListingPage";
import FaqCategoryEditingPage from "../FaqCategoryEditingPage";


export default function CineclubSection(props) {
  const { match } = props;
  const { userPermissions } = useContext(PermissionContext);
  console.log(match.url);
  return (
    userPermissions && (
      <Layout menuObj={menu}>
        <Switch>
          <Route
            exact
            path={`${match.url}/membership/member`}
            component={withPermission(
              MemberListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/member/:id`}
            component={withPermission(
              MemberDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/member/record/:id`}
            component={withPermission(
              MemberRecordPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/plan`}
            component={withPermission(
              MemberPlanListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/plan/:id`}
            component={withPermission(
              MemberPlanDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/plan-feature`}
            component={withPermission(
              PlanFeatureListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/plan-feature/new`}
            component={withPermission(
              PlanFeatureEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/plan-feature/:id/edit`}
            component={withPermission(
              PlanFeatureEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          {/* <Route
            exact
            path={`${match.url}/membership/gift`}
            component={withPermission(
              MemberGiftListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/gift/:id`}
            component={withPermission(
              MemberGiftDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          /> */}
          <Route
            exact
            path={`${match.url}/membership/configuration`}
            component={withPermission(
              MemberConfigurationPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/email`}
            component={withPermission(
              MemberEmailSettingsPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/email/:templateType/edit`}
            component={withPermission(
              MemberEmailSettingsPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/orders`}
            component={withPermission(
              OrderListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/orders/:id`}
            component={withPermission(
              OrderDetailsPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/eshop/vouchers`}
            component={withPermission(
              VoucherListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/eshop/vouchers/create`}
            component={withPermission(
              VoucherEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/eshop/vouchers/:id/edit`}
            component={withPermission(
              VoucherEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/eshop/vouchers/:id`}
            component={withPermission(
              VoucherDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/eshop/coupons`}
            component={withPermission(
              CouponListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/eshop/coupons/create`}
            component={withPermission(
              CouponEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/eshop/coupons/:id/edit`}
            component={withPermission(
              CouponEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/eshop/coupons/:id`}
            component={withPermission(
              CouponDetailsPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/eshop/merchandise`}
            component={withPermission(
              MerchandiseListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/eshop/merchandise/create`}
            component={withPermission(
              MerchandiseEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/eshop/merchandise/:id/edit`}
            component={withPermission(
              MerchandiseEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/banners`}
            component={withPermission(
              BannerListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/banners/create`}
            component={withPermission(
              BannerEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/banners/:id/edit`}
            component={withPermission(
              BannerEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/partners`}
            component={withPermission(
              PartnerBenefitListPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/partners/create`}
            component={withPermission(
              PartnerBenefitEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/partners/:id/edit`}
            component={withPermission(
              PartnerBenefitEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/news`}
            component={withPermission(
              NewsListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/news/create`}
            component={withPermission(
              NewsEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/news/:id/edit`}
            component={withPermission(
              NewsEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/faq`}
            component={withPermission(
              FaqListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/faq/create`}
            component={withPermission(
              FaqEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/faq/:id/edit`}
            component={withPermission(
              FaqEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/faq/category`}
            component={withPermission(
              FaqCategoryListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/faq/category/create`}
            component={withPermission(
              FaqCategoryEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/faq/category/:id/edit`}
            component={withPermission(
              FaqCategoryEditingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />

          <Route
            render={() => <Redirect to={`${match.url}/membership/member`} />}
          />
        </Switch>
      </Layout>
    )
  );
}
